import React, { useState } from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';

import { RotateAnimatedView } from 'components/ui/rotate-animated-view';
import { t } from 'state/intl/translations';

import { StyledButton, StyledIcon } from './styled';
import { CloseButtonProps } from './types';

const CloseButton = ({
  onClick,
  inverted = false,
  noBackground = true,
  _svg,
  icon = 'cancel',
  skipRotateAnimation = false,
  skipPressAnimation = false,
  ...props
}: CloseButtonProps) => {
  const [isRotated, setIsRotated] = useState(false);
  const rotateIn = () => {
    if (!skipRotateAnimation) {
      setIsRotated(true);
    }
  };
  const rotateOut = () => {
    if (!skipRotateAnimation) {
      setIsRotated(false);
    }
  };

  return (
    <StyledButton
      variant={inverted ? 'ghost-reversed' : 'ghost'}
      onPress={onClick}
      onPressIn={rotateIn}
      onPressOut={rotateOut}
      onHoverIn={rotateIn}
      onHoverOut={rotateOut}
      noBackground={noBackground}
      testID="close-button"
      accessibilityLabel={t('close')}
      inverted={inverted}
      {...props}
      _pressed={skipPressAnimation ? undefined : { style: { transform: [{ scale: 0.9 }] } }}
    >
      <RotateAnimatedView isRotated={isRotated && !skipRotateAnimation} toDeg={90}>
        <StyledIcon variant={icon} inverted={inverted} {..._svg} />
      </RotateAnimatedView>
    </StyledButton>
  );
};

export default makeUclComponent(CloseButton);
